import { InvitationEffects } from "@organizations/store/effects/invitation.effects";
import { LocationEffects } from "@organizations/store/effects/location.effects";
import { OrganizationAssignableRoleEffects } from "@organizations/store/effects/organization-assignable-role.effects";
import { OrganizationAssociatedProductEffects } from "@organizations/store/effects/organization-associated-product.effects";
import { OrganizationIssuerEffects } from "@organizations/store/effects/organization-issuer.effects";
import { OrganizationEffects } from "@organizations/store/effects/organization.effects";
import { OuEffects } from "@organizations/store/effects/ou.effects";
import { ProductEffects } from "@organizations/store/effects/product.effects";
import { RoleAssignmentEffects } from "@organizations/store/effects/role-assignment.effects";

export const effects = [
  InvitationEffects,
  LocationEffects,
  OrganizationAssignableRoleEffects,
  OrganizationAssociatedProductEffects,
  OrganizationEffects,
  OrganizationIssuerEffects,
  OuEffects,
  ProductEffects,
  RoleAssignmentEffects
];

export * from "@organizations/store/effects/invitation.effects";
export * from "@organizations/store/effects/location.effects";
export * from "@organizations/store/effects/organization-assignable-role.effects";
export * from "@organizations/store/effects/organization-associated-product.effects";
export * from "@organizations/store/effects/organization-issuer.effects";
export * from "@organizations/store/effects/organization.effects";
export * from "@organizations/store/effects/ou.effects";
export * from "@organizations/store/effects/product.effects";
export * from "@organizations/store/effects/role-assignment.effects";
